import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();

  const masterPortalUrl = process.env.REACT_APP_MASTER_PORTAL_URL || "http://localhost:5173";

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          window.location.href = masterPortalUrl;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [masterPortalUrl]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    try {
      await login(form);
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid email or password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page-wrapper">
      <div className="auth-card">
        <div className="auth-header">
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.75rem',
            marginBottom: '1.5rem'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              backgroundColor: 'white',
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '4px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              flexShrink: 0
            }}>
              <img 
                src="/Media_Logo.png" 
                alt="Delta Media" 
                style={{ 
                  width: '100%', 
                  height: '100%', 
                  objectFit: 'contain',
                  borderRadius: '6px'
                }} 
              />
            </div>
            <div className="auth-brand" style={{ marginBottom: 0 }}>DELTA MEDIA</div>
          </div>
          <h2>Welcome Back</h2>
          <div style={{
            marginBottom: '1.5rem',
            padding: '1rem',
            backgroundColor: '#fff7ed',
            border: '1px solid #ffedd5',
            borderRadius: '0.75rem',
            color: '#9a3412',
            fontSize: '0.85rem',
            textAlign: 'center'
          }}>
            <p style={{ fontWeight: 600, marginBottom: '0.25rem' }}>Please login through the Master Portal</p>
            <p style={{ opacity: 0.8, marginBottom: '0.5rem' }}>Redirecting in {countdown} seconds...</p>
            <a href={masterPortalUrl} style={{ color: '#2563eb', textDecoration: 'underline' }}>
              Go to Master Portal now
            </a>
          </div>
          <p>Sign in to manage your media bookings</p>
        </div>

          <form onSubmit={handleSubmit} className="auth-form" style={{ display: 'none' }}>
          <div className="auth-field">
            <label>Email Address</label>
            <input
              className="auth-input"
              type="email"
              placeholder="name@company.com"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
            />
          </div>

          <div className="auth-field">
            <label>Password</label>
            <div className="password-input-wrapper">
              <input
                className="auth-input"
                style={{ width: '100%', paddingRight: '3rem' }}
                type={showPassword ? 'text' : 'password'}
                placeholder="••••••••"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                required
              />
              <span 
                className="password-toggle-icon"
                onClick={() => setShowPassword(!showPassword)}
                title={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? '👁️' : '🙈'}
              </span>
            </div>
            <div style={{ textAlign: 'right', marginTop: '0.25rem' }}>
              <span 
                className="auth-link" 
                style={{ fontSize: '0.8rem' }}
                onClick={() => navigate('/forgot-password')}
              >
                Forgot password?
              </span>
            </div>
          </div>

          {error && <div className="auth-error">{error}</div>}

          <button className="auth-submit-btn" type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div className="auth-footer">
          Delta Media Management System
        </div>
      </div>
    </div>
  );
}
